import React from 'react';
import CountUp from 'react-countup';
import { Col, Row } from 'reactstrap';

const Counter2 = () => {
    return (
        <Row className="text-center">
            <Col lg="6" md="6">
                <div className="counter bg-primary rounded p-5 shadow">
                    <div className="counter-desc text-white">
                        <h5>Rapoarte intocmite</h5>
                        <CountUp className="count-number display-4" end={1000} duration={50} />
                        <span className="display-4">+</span>
                    </div>
                </div>
            </Col>
            <Col lg="6" md="6" className="mt-5">
                <div className="counter bg-white rounded p-5 shadow">
                    <div className="counter-desc">
                        <h5>Clienți activi</h5>
                        <CountUp className="count-number display-4 text-primary" end={20} duration={50} />
                        <span className="display-4 text-primary">+</span>
                    </div>
                </div>
            </Col>
            <Col lg="6" md="6" className="mt-5 mt-md-0">
                <div className="counter bg-white rounded p-5 shadow">
                    <div className="counter-desc">
                        <h5>Ani experiență</h5>
                        <CountUp className="count-number display-4 text-primary" end={10} duration={30} />
                        <span className="display-4 text-primary">+</span>
                    </div>
                </div>
            </Col>
            <Col lg="6" md="6" className="mt-5">
                <div className="counter bg-orange rounded p-5 shadow">
                    <div className="counter-desc text-white">
                        <h5>Locații Monitorizate</h5>
                        <CountUp className="count-number display-4" end={60} duration={50} />
                        <span className="display-4">+</span>
                    </div>
                </div>
            </Col>
        </Row>
    );
};

export default Counter2;
